<template>
  <div class="myProfit">
  	<van-pull-refresh class="income" v-model="isLoading" @refresh="onRefresh" v-if="list.length != 0">
			<van-list
			  v-model="loading"
			  :finished="finished"
			  finished-text="没有更多了"
			  @load="onLoad"
			>
			  	<van-cell class="income_" v-for="(item, index) in list" :key="index" @click="detail(item.project.id, item.project.project_type)">
			        <div class="income_l">
			          <img :src="item.project.poster" @error="nofind()">
			        </div>
			        <div class="income_r">
			          <p class="income-title">{{item.project.project_name}}</p>
			          <p class="new">今日持股收益 | 持股数 {{item.shares}}股</p>
			          <p class="coin">{{item.price_1}}<span>.</span><span>{{item.price_2}}</span><span>红包</span></p>
			        </div>
			  	</van-cell>
			</van-list>
		</van-pull-refresh>
    
    <van-row class="empty" v-if="list.length == 0 && !hasList">
			<van-col class="emptyMsg" span="24">
				<img src="../../assets/myInvest/empty.png"/>
				<p class="tip">暂无相关收益</p>
			</van-col>
		</van-row>
		<div class="loading" v-if="list.length <= 0 && hasList">
    	<img src="../../assets/common/loading.gif"/>
    </div>
  </div>
</template>
<script>
import defaultImg from '@/assets/common/compare.png';
export default {
	data() {
	    return {
					list: [],
	      	loading: false,
	      	finished: false,
	      	isLoading: false,
	        page: 1,
	        pageSize: 10,
	        allList: 11, //默认比第一页数据多1
        	hasList: true
	    };
	},
	created() {
		if(this.$route.query.token) {
			this.$api.setToken(this.$route.query.token)
		}
	　this.getInfo();
	},
	methods: {
		onLoad() {
	      // 异步更新数据
	      setTimeout(() => {
	      	this.page ++;
	      	this.getInfo();
		      	
	        // 加载状态结束
	        this.isLoading = false;
	      }, 500);
	    },
	    onRefresh() {
	    	this.page = 1;
			this.finished = false;
	    	this.list = [];
		    this.getInfo();
	    },
	    getInfo() {
	    	this.$api.get("/investment/member/account/list", {page: this.page}).then(res => {
		        this.allList = res.total;
		    	if (res.list.length == 0) {
		        	this.hasList = false;
		        }
		        if(res.list.length > 0) {
		        	for(let i in res.list) {
		        		if(res.list[i].today_coin_increase == null || res.list[i].today_coin_increase == 0) {
		        			res.list[i].price_1 = 0;
		        			res.list[i].price_2 = '0000';
		        		}else {
		        			res.list[i].today_coin_increase = res.list[i].today_coin_increase.toFixed(4).toString();
		        			res.list[i].price_1 = res.list[i].today_coin_increase.split('.')[0];
			  					res.list[i].price_2 = res.list[i].today_coin_increase.split('.')[1];
		        		}
		        		
			        	this.list.push(res.list[i]);
			        }
		        }
		        this.loading = false;
		        if (this.list.length >= this.allList) {// 数据全部加载完成
		          this.finished = true;
		        }
		        if(this.isLoading) {
		        	this.$toast('刷新成功');
	        		this.isLoading = false;
		        }
	      }).catch(err => {
          this.hasList = false;
	        let keys = Object.keys(err);
		     	let key = keys[0];
		  		let message = err.message || err[key][0]
		  		if(message.slice(0, 10) == 'timeout of') {
		  			this.$toast('网络不给力，请稍候重试');
		  			this.timeout = true;
		  		}else {
		  			this.$toast(message);
		  		}
	        });
	  	},
	  	detail(id, type) {
	  		if(type == 1) {
	  			this.$router.push({
				    path: "/myInvest/earning",
				    query: {
				        id: id
				    }
		    	});
	  		}else if(type == 2) {
	  			this.$router.push({
				    path: "/myInvest/earning_order",
				    query: {
				        id: id
				    }
		    	});
	  		}
	  		
	  	},
	  	nofind() {
		    var img = event.srcElement;
				img.src = defaultImg;
				img.onerror = null; //防止闪图
		}
	}
};
</script>
<style lang="less" scoped>
.myProfit {
	height: 100%;
  background-color: #eeeeee;
  .income {
    padding: 85px 16px 50px 16px;
    box-sizing: border-box;
    height: 100%;
		overflow-y: scroll;
		-webkit-overflow-scrolling:touch;
    .income_ {
      display: flex;
      padding: 16px;
      background-color: #fff;
      box-shadow: 0px 4px 24px 0px rgba(153, 153, 153, 0.12);
      border-radius: 8px;
      margin-top: 16px;
      margin-bottom: 16px;
      .income_l {
        width: 100px;
        height: 75px;
        background: #f5f5f5;
        border-radius: 5px;
        float: left;
        img {
          width: 100%;
          height: 100%;
          border-radius: 3px;
        }
      }
      income_r{
      	width: 100%;
      	padding-left: 111px;
      	padding-right: 20px;
      }
      @media screen and (max-width: 374px) {
        .income_l {
          width: 90px;
        }
      }
      .income_r {
				padding-left: 112px;
      	padding-right: 20px;
        p {
          margin-bottom: 8px;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
        .new {
          margin-bottom: 3px;
        }
        .income-title {
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          line-height: 22px;
        }
        @media screen and (max-width: 414px) {
          .income-title {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .coin {
          font-size: 18px;
          color: #d29a6e;
          font-weight: 500;
          line-height: 23px;
          margin-bottom: 0;
          span:not(:first-child) {
            font-size: 12px;
          }
        }
      }
      @media screen and (max-width: 320px) {
        .income_l {
          width: 90px;
        }
        .income_r {
              padding-left: 101px;
          padding-right: 0;
         
        }
      }
    }
  }
  .empty {
		padding-top: 200px;
		.emptyMsg {
			text-align: center;
			img {
				width: 106px;
				display: inline-block;
			}
			.tip {
				color: #CCCCCC;
				font-size: 14px;
				margin-top: 17px;
				height: 20px;
				line-height: 20px;
			}
		}
	}
	.loading{
		width: 100%;
		/*padding-top: 100px;*/
		text-align: center;
		img {
			width: 35%;
			margin-top: 50%;
		}
	}
}
.isiOSX .myProfit .income{
	padding-top: 89px;
}
</style>


